import { render, staticRenderFns } from "./TextEditModal.vue?vue&type=template&id=4aa4bb0a"
import script from "./TextEditModal.vue?vue&type=script&lang=js"
export * from "./TextEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports